import React from 'react';
import axios from 'axios';
import qs from 'qs';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

const styles = () => ({
  consentButtonsWrapper: {
    marginBottom: 20,
  },
  consentButton: {
    marginRight: 10,
  },
  saveButtonWrapper: {
    textAlign: 'right',
    marginTop: 10,
  },
});

class AnnouncementConsentActionButtons extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      consent: props.consent,
      consentGiven: props.consent?.consent_given ?? null,
      consentComment: props.consent?.comment ?? '',
    };

    this.onConsentButtonClick = this.onConsentButtonClick.bind(this);
    this.onSaveButtonClick = this.onSaveButtonClick.bind(this);
    this.onConsentCommentChange = this.onConsentCommentChange.bind(this);
  }

  onConsentButtonClick(value, pupilId) {
    const {
      t,
      enqueueSnackbar,
      announcement,
    } = this.props;
    const {
      consent,
      consentComment,
    } = this.state;

    if (!announcement) {
      enqueueSnackbar(t('Announcement not found.'), {
        variant: 'error',
        autoHideDuration: 2000,
      });

      return;
    }

    let url = `${window.apiUrl}/createannouncementconsent/${announcement.id}`;

    let newState = {
      consentGiven: value,
      consentComment,
    };
    if (
      consent &&
      consent.consent_given !== newState.consentGiven
    ) {
      url = `${window.apiUrl}/updateannouncementconsent/${consent.id}`;
    } else if (
      consent &&
      consent.consent_given === newState.consentGiven
    ) {
      url = `${window.apiUrl}/removeannouncementconsent/${consent.id}`;

      newState.consentGiven = null;
      newState.consentComment = '';
    }

    this.setState(newState);

    axios
      .post(url, qs.stringify({
        pupil_id: pupilId,
        consent_given: newState.consentGiven,
        comment: newState.consentComment,
      }))
      .then((response) => {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        } else {
          this.setState({
            consent: response.data.data.id
              ? response.data.data
              : null,
          });

          enqueueSnackbar(t('You have successfully updated the consent'), {
            variant: 'success',
            autoHideDuration: 2000,
          });
        }
      })
      .catch((thrown) => {});
  }

  onSaveButtonClick() {
    const {
      t,
      enqueueSnackbar,
    } = this.props;
    const {
      consent,
      consentGiven,
      consentComment,
    } = this.state;

    const url = `${window.apiUrl}/updateannouncementconsent/${consent.id}`;

    axios
      .post(url, qs.stringify({
        consent_given: consentGiven,
        comment: consentComment,
      }))
      .then((response) => {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        } else {
          enqueueSnackbar(t('You have successfully updated the consent comment'), {
            variant: 'success',
            autoHideDuration: 2000,
          });
        }
      })
      .catch((thrown) => {});
  }

  onConsentCommentChange(event) {
    this.setState({
      consentComment: event.target.value,
    });
  }

  render() {
    const {
      classes,
      t,
      pupilId,
    } = this.props;
    const {
      consentGiven,
      consentComment,
    } = this.state;

    return (
      <div className="announcement-consent-action-buttons">
        <div className={classes.consentButtonsWrapper}>
          <Button
            onClick={this.onConsentButtonClick.bind(this, 'yes', pupilId)}
            color={consentGiven === 'yes' ? 'secondary' : 'inherit'}
            variant={consentGiven === 'yes' ? 'contained' : 'outlined'}
            className={`consent-button ${classes.consentButton}`}
          >
            {t('Give Consent')}
          </Button>
          <Button
            onClick={this.onConsentButtonClick.bind(this, 'no', pupilId)}
            color={consentGiven === 'no' ? 'secondary' : 'inherit'}
            variant={consentGiven === 'no' ? 'contained' : 'outlined'}
            className={`do-not-consent-button ${classes.consentButton}`}
          >
            {t('Do not Consent')}
          </Button>
        </div>
        {consentGiven && (
          <>
            <TextField
              fullWidth
              multiline
              margin="dense"
              label={t('Comment')}
              value={consentComment}
              onChange={this.onConsentCommentChange}
            />
            <div className={classes.saveButtonWrapper}>
              <Button
                onClick={this.onSaveButtonClick}
                color="secondary"
                variant="contained"
                className="save-comment"
              >
                {t('Save comment')}
              </Button>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(withSnackbar(withTranslation()(AnnouncementConsentActionButtons)));
